module.exports = __webpack_public_path__ + "img/icon-decline-white.edbd536d.svg";